const myBookingsES = {
	upcomingTitle: "Próximas",
	upcomingSubLoading: "Cargando...",
	upcomingSubCount: (count) => `${count} confirmadas`,
	noUpcoming: "No hay reservas próximas",
	emailSent: "Correo enviado",
	addToCalendar: "Añadir al Calendario",
	reschedule: "Reprogramar",
	cancel: "Cancelar",

	historyTitle: "Historial",
	historySub: "Tus visitas anteriores",
	noHistory: "Aún no hay visitas anteriores",

	table: {
		date: "Fecha",
		service: "Servicio",
		shop: "Negocio",
		status: "Estado",
	},

	errors: {
		load: "No pudimos cargar tus reservas. Inténtalo de nuevo.",
		cancel: "No pudimos cancelar tu reserva. Inténtalo de nuevo.",
		reload: "No pudimos actualizar tus reservas.",
		reschedule: "No pudimos abrir la reprogramación. Inténtalo de nuevo.",
	},
};

export default myBookingsES;
